import { Paper } from '@mui/material'
import React from 'react'
import "./Clients.css"
import { EditorManager } from './EditorManager'

export const ClientSections = ({client_id, editor_data, refreshDetails, setRefreshDetails}) => {
  return (
    <div className='container-cliensections'>
    <Paper sx={{margin:'10px', height:'100%'}} variant='elevation'>
    <div className='section-container'>
       
        <EditorManager client_id={client_id} editorData={editor_data} ></EditorManager>
    </div>
    </Paper>
    </div>
  )
}
